import { blue, slate } from '@/lib/colours';

export const LANDING_MAX_WIDTH_PX = 1216;

export const sectionShell = {
  width: '100%',
  margin: '0 auto',
  maxWidth: `${LANDING_MAX_WIDTH_PX}px`,
  px: { xs: `${20}px`, md: `${64}px` },
};

export const darkSectionBg = {
  backgroundColor: slate[950],
  backgroundImage: `
    linear-gradient(180deg, ${slate[950]} 0%, ${slate[900]} 45%, ${slate[950]} 100%),
    linear-gradient(rgba(59, 130, 246, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(59, 130, 246, 0.06) 1px, transparent 1px)
  `,
  backgroundSize: '100% 100%, 48px 48px, 48px 48px',
};

export const lightSectionBg = {
  backgroundColor: slate[50],
};

export const mutedSectionBg = {
  backgroundColor: slate[100],
};

export const accentGlow = {
  background: `radial-gradient(ellipse 80% 60% at 50% -30%, ${blue[600]}33, transparent 55%)`,
};

/** Slightly brighter than `darkSectionBg` — used only for the top hero. */
export const heroSectionBg = {
  backgroundColor: slate[900],
  backgroundImage: `
    linear-gradient(180deg, ${slate[900]} 0%, ${slate[800]} 42%, ${slate[900]} 100%),
    linear-gradient(rgba(59, 130, 246, 0.085) 1px, transparent 1px),
    linear-gradient(90deg, rgba(59, 130, 246, 0.085) 1px, transparent 1px)
  `,
  backgroundSize: '100% 100%, 48px 48px, 48px 48px',
};

export const heroAccentGlow = {
  background: `radial-gradient(ellipse 85% 65% at 50% -28%, ${blue[500]}40, transparent 58%)`,
};
